import { createSelector } from '@reduxjs/toolkit';

const getChannelListState = (state) => state.channelList;

export const getSearchInput = createSelector(getChannelListState, (channelList) => channelList.searchInput);
